export class UploadedFilePreview{

    public readonly url: string;
    public readonly type: string;

    constructor(url: string, type: string) {
        this.url = url;
        this.type = type;
    }
}
